import * as React from 'react';
import { EditOutlined } from '@ant-design/icons';
import DeliverySettingsModal from './components/Modal';

interface IDeliverySettingsProps {
  order: GQL.IOrder;
  onUpdate: (data: any) => void;
}

interface IDeliverySettingsState {
  modalOpened: boolean;
}

class DeliverySettings extends React.Component<IDeliverySettingsProps, IDeliverySettingsState> {

  constructor(props: IDeliverySettingsProps) {
    super(props);

    this.state = {
      modalOpened: false,
    };

    this.onToggleModal = this.onToggleModal.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }
  
  public render() {
    const { order } = this.props;

    return (
      <React.Fragment>
        <div className="editBlock delivery" onClick={this.onToggleModal}>

          <div className="icon">
            <EditOutlined onClick={this.onToggleModal} />
          </div>

          <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
            <span style={{ color: '#999897' }}>Name</span>
            <span>{order.deliveryFirstName} {order.deliveryLastName}</span>
          </div>
          <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
            <span style={{ color: '#999897' }}>Phone</span>
            <span>{order.deliveryPhone}</span>
          </div>
          <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
            <span style={{ color: '#999897' }}>Street address</span>
            <span>{order.deliveryAddressLine1}</span>
          </div>
          {order.deliveryAddressLine2 &&
            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
              <span style={{ color: '#999897' }}>Address line 2</span>
              <span>{order.deliveryAddressLine2}</span>
            </div>}
          <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
            <span style={{ color: '#999897' }}>City & Zip</span>
            <span>{order.deliveryCity}, {order.deliveryZip}</span>
          </div>
          {order.deliveryCountyState &&
            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
              <span style={{ color: '#999897' }}>County / State</span>
              <span>{order.deliveryCountyState}</span>
            </div>}
          <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
            <span style={{ color: '#999897' }}>Country</span>
            <span>{order.deliveryCountry}</span>
          </div>
        </div>

        {this.state.modalOpened &&
          <DeliverySettingsModal 
            order={order}
            onSubmit={this.onSubmit}
            onClose={this.onToggleModal}
          />}
      </React.Fragment>
    );
  }

  private onToggleModal() {
    this.setState({
      modalOpened: !this.state.modalOpened,
    });
  }

  private async onSubmit(data: any) {
    await this.props.onUpdate(data);
    this.onToggleModal();
  }
}

export default DeliverySettings;


// WEBPACK FOOTER //
// ./src/scenes/OrderView/OrderView/DeliverySettings/DeliverySettings.tsx